<template>
  <div
    @keydown.esc.stop
    v-on:lock="noScroll()"
    v-on:unlock="scroll()"
    :no-close-on-esc="false"
    :md-click-outside-to-close="false"
    @keydown.tab="handleContestTabNavigation($event)"
    id="preference-modal2"
  >
    <md-progress-bar md-mode="indeterminate" v-show="!loaded"></md-progress-bar>

    <div
      v-if="preference && contestList"
      class="md-layout"
      v-bind:class="hidediv ? 'dis' : ''"
      id="preferenceDiv"
    >
      <!-- Alert per pari opportunità -->
      <div
        class="title-alert"
        v-if="
          electionType && electionType.indexOf('EQUAL_OPPORTUNITIES') !== -1
        "
      >
        <b v-if="electionType == 'AIDED_EQUAL_OPPORTUNITIES'">
          {{ $t("preference.not-three.sex-preference") }}</b
        >
        <span v-if="electionType == 'AIDED_THREE_EQUAL_OPPORTUNITIES'">
          {{ $t("preference.three.sex-preference") }}</span
        >
      </div>

      <div class="md-layout md-layout-item md-size-100">
        <span
          v-if="orderedContests.length > 1 || unorderedContests.length > 1"
          class="screenreader"
        >
          {{ $t("preference.screen-reader.tab-partition") }}</span
        >
        <md-tabs
          class="light-w "
          v-if="preference && contestList"
          md-alignment="centered"
          @md-changed="changeTab"
          id="esterno"
          :class="
            orderedContests.length > 1 || unorderedContests.length > 1
              ? ''
              : 'no-navigation'
          "
        >
          <md-tab
            class="dialog"
            id="page0"
            :md-label="$t('preference.how-to-vote-tab.title')"
            v-if="orderedContests.length > 1 || unorderedContests.length > 1"
            :md-disabled="changed"
            :aria-hidden="changed"
          >
            {{ $t("preference.how-to-vote-tab.intro") }}.
            <p>
              <strong
                >{{
                  $t("preference.how-to-vote-tab.alphabetical-order")
                }}:</strong
              >
              {{
                $t("preference.how-to-vote-tab.alphabetical-select-and-vote")
              }}.
            </p>

            <p>
              <strong
                >{{ $t("preference.how-to-vote-tab.different-order") }}:</strong
              >
              {{ $t("preference.how-to-vote-tab.different-select-and-vote") }}.
            </p>

            <p>{{ $t("preference.how-to-vote-tab.blank-vote") }}.</p>
          </md-tab>
          <!--tab DISABILITATO per PIÙ pagine -->
          <md-tab
            class="dialog"
            style="padding: 0px;"
            :id="contest.Id"
            aria-hidden="true"
            :md-disabled="
              orderedContests.length > 0 || unorderedContests.length > 1
                ? false
                : true
            "
            :md-label="
              orderedContests.length > 0 || unorderedContests.length > 1
                ? checkContestName(contest.ContestName)
                  ? contest.ContestName.includes('Pagina')
                    ? contest.ContestName.replace(
                        'Pagina',
                        $t('preference.how-to-vote-tab.page')
                      )
                    : contest.ContestName
                  : ''
                : ''
            "
            v-for="contest in unorderedContests"
            :key="contest.Id"
          >
            <div class="md-subtitle" style="padding: 16px;">
              {{
                $t("election.candidates-list") +
                  " " +
                  labelContesto(
                    contest.ContestName != null && contest.ContestName != ""
                      ? contest.ContestName.includes("Pagina")
                        ? contest.ContestName.replace(
                            "Pagina",
                            $t("preference.how-to-vote-tab.page")
                          )
                        : contest.ContestName
                      : "",
                    $t("election-event.screen-reader.from-date"),
                    $t("election-event.screen-reader.to-date")
                  )
              }}
              <span aria-hidden="true"
                >{{ $t("preference.scroll-page-indication") }}.</span
              >
              <span class="screenreader"
                >{{ $t("preference.screen-reader.indication") }}:
                {{ preference.MaxVotes }}</span
              >
              <br />
            </div>
            <infoBox
              style="padding: 0 15px"
              v-if="utils.getViewInfoBox()"
              :showNullVote="false"
              :listOrCandidates="'PREFERENCE'"
            ></infoBox>
            <contest
              :contestId="contest.Id"
              class="dialog md-layout bg-preference"
              @candidateInContestSelected="selectCandidateInContest"
              @contestRetrieved="loaded = true"
              @num-cand-or-aff="numberCandidates"
              :disabled="tooMany"
              :electionType="electionType"
              listOrCandidates="CANDIDATES"
              v-if="!contest.Category"
              :sexVoted="sexVoted"
              :electionId="electionId"
              :previousVoted="voted"
              :loadContest="
                unorderedContests.length > 1 ? contestNames[contest.Id] : true
              "
              :loadDeferredContest="loadDeferredContest"
              :visibleContest="visibleContests[contest.Id]"
            >
            </contest>
          </md-tab>

          <!--tab DISABILITATO per pagina SINGOLA -->
          <md-tab
            class="dialog"
            :id="contestGroup.elements[0].Category"
            aria-hidden="true"
            :md-label="contestGroup.elements[0].Category"
            v-for="contestGroup in orderedContests"
            :key="contestGroup.elements[0].Category"
          >
            <md-tabs md-alignment="fixed">
              <md-tab
                class="dialog"
                :id="contest.Id"
                aria-hidden="true"
                :md-label="contest.ContestName"
                v-for="contest in contestGroup.elements"
                :key="contest.Id"
              >
                <infoBox
                  style="padding: 0 15px"
                  v-if="utils.getViewInfoBox()"
                  :showNullVote="false"
                  :listOrCandidates="'PREFERENCE'"
                ></infoBox>
                <contest
                  :contestId="contest.Id"
                  class="dialog md-layout"
                  @candidateInContestSelected="selectCandidateInContest"
                  @contestRetrieved="loaded = true"
                  @num-cand-or-aff="numberCandidates"
                  :disabled="tooMany"
                  :electionType="electionType"
                  listOrCandidates="CANDIDATES"
                  :sexVoted="sexVoted"
                  :electionId="electionId"
                  :previousVoted="voted"
                  :loadContest="
                    unorderedContests.length > 1
                      ? contestNames[contest.Id]
                      : true
                  "
                  :loadDeferredContest="loadDeferredContest"
                  :visibleContest="true"
                >
                </contest>
              </md-tab>
            </md-tabs>
          </md-tab>
        </md-tabs>
      </div>
      <div class="toolbar innertoolbar toolbar-w">
        <md-card class="md-layout-item md-size-100 toolbar-w">
          <div class="md-layout">
            <div
              class="md-layout-item  md-size-30 md-caption mg preferenze-label"
            >
              <!--aria-live="assertive"-->
              <span class="screenreader"
                >{{ $t("preference.screen-reader.preferences-summary") }}:
              </span>
              {{ $t("preference.max-number") }}: {{ preference.MaxVotes }}<br />
              <span class="screenreader">
                {{ $t("preference.screen-reader.and") }}
              </span>
              {{ $t("preference.selected-number") }}: {{ voted.length }}
            </div>

            <div
              id="preferencesVoteButtons"
              class="md-layout-item btn-align mg md-size-40"
              style="margin-left: 0px;margin-right: 0px;"
            >
              <md-button
                id="noPreference"
                @click="vote"
                class="md-raised md-accent"
                style="margin-left: 0px;margin-right: 8px;"
                :disabled="ready"
                :aria-disabled="ready"
              >
                <md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{ $t("preference.no-preferences-button") }}
                </md-tooltip>
                {{ $t("preference.no-preferences-button") }}
              </md-button>
              <md-button
                id="confirmPreference"
                @click="vote"
                class="md-raised md-primary md-mini"
                style="margin-left: 0px;margin-right: 8px;"
                :disabled="!ready"
                :aria-disabled="!ready"
              >
                <md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{ $t("preference.confirm-preferences-button") }}
                </md-tooltip>
                {{ $t("preference.confirm-preferences-button") }}
              </md-button>
            </div>
          </div>
        </md-card>
      </div>

      <no-all-preference-dialog
        @opened="
          hidediv = true;
          $root.$emit('afflock');
          noScroll();
        "
        @closed="
          hidediv = false;
          $root.$emit('affunlock');
          scroll();
        "
        :confirmVoteDialog="confirmVoteDialog"
        @openFinalConfirm="
          confirmVote();
          confirmVoteDialog = false;
          closeConfirm();
        "
        @cancel="confirmVoteDialog = false"
      ></no-all-preference-dialog>
    </div>
  </div>
</template>

<script>
import PreferenceMixin from "./PreferenceLogicMixin";
import Utils from "../utils/Utils.js";
import NoAllPreferenceDialog from "./NoAllPreferenceDialog";
// import EqualOppDialog from "./EqualOppDialog";
import InfoBox from "./InfoBox";

import { isMobile } from "mobile-device-detect";

const LOAD_DEFERRED_CONTEST = process.env.VUE_APP_deferred_contest_loading;
//const LOAD_DEFERRED_CONTEST = false;

export default {
  mixins: [PreferenceMixin],
  mounted() {
    this.isMobile = isMobile;
    this.loadDeferredContest =
      this.loadDeferredContest == null ? false : this.loadDeferredContest;

    if (this.previousVoted && process.env.VUE_APP_persistPreference == "true") {
      this.previousVoted.forEach(c => {
        this.voted.push(c);
      });
    }
    this.confirmEqual = this.voted.length == 0 ? true : false;

    this.checkIfReady();
    this.utils = new Utils();
    this.getPreference();

    document
      .getElementById("election-modal")
      .setAttribute("aria-hidden", "true");
  },
  data: function() {
    return {
      contestList: [],
      voted: [],
      ready: false,
      alLeastOne: false,
      tooMany: false,
      contestNames: {},
      visibleContests: {},
      selectedContests: {},
      confirmVoteDialog: false,
      equalOpps: false,
      utils: null,
      changed: false,
      confirmEqual: true,
      hidediv: false,
      loaded: false,
      loadDeferredContest: LOAD_DEFERRED_CONTEST,
      isMobile: false,
      numCandidates: 0,
      lastFocus: "",
      activeTab: null
    };
  },
  props: ["preference", "electionType", "previousVoted", "electionId"],
  methods: {
    selectCandidateInContest(evt) {
      //invoca il metodo del minix
      this.candidateSelected(evt);

      //controlla se nel contesto scelto è stato selezionato almeno un candidato
      let hasContestSelectedCandidates =
        this.voted.filter(item => item.contestId === evt.contestId).length > 0;

      //memorizza se nel contesto attuale è stato scelto almeno un candidato
      this.selectedContests[evt.contestId] = hasContestSelectedCandidates;
    },
    noScroll() {
      // document.documentElement.style.overflow = "hidden";
      this.lastFocus = document.activeElement;
      this.hidediv = true;
      this.$forceUpdate();
    },
    scroll() {
      // document.documentElement.style.overflow = "auto";
      this.lastFocus.focus();
      this.hidediv = false;
      this.$forceUpdate();
    },
    closeConfirm() {
      document
        .getElementById("election-modal")
        .setAttribute("aria-hidden", "false");
      document.getElementById("vote").focus();
    },
    async getPreference() {
      this.$emit("preferenceRetrieved");
      this.contestList = this.preference.ChoicesContest.map(id => {
        return {
          Id: id.ChoicesContestIdentifier.Id,
          Category: id.ChoicesContestIdentifier.Category,
          ContestName: id.ChoicesContestIdentifier.ContestName
        };
      });
      this.loaded = true;
      this.contestList.forEach(el => {
        this.contestNames[el.Id] = this.contestLevels == 0;
        this.visibleContests[el.Id] = this.contestLevels == 0;
        this.selectedContests[el.Id] = false;
      });
    },

    changeContestName(evt) {
      // this.contestNames[evt.id] = evt.name;
      // this.$forceUpdate();
    },

    changeTab(evt) {
      if (evt != "page0" && evt != undefined) {
        this.activeTab = evt;
        this.$emit("activeTab", this.activeTab);
        this.changed = true;
        let found;
        this.orderedContests.forEach(el => {
          if (el.name == evt) found = true;
        });
        if (!found && !this.contestNames[evt]) {
          this.loaded = false;
        }
        this.contestNames[evt] = true;

        if (this.contestLevels === 1) {
          let visibleContestKeys = Object.keys(this.visibleContests);

          //per tutti i contesti viene deciso se sono visibili o meno
          visibleContestKeys.forEach(visibleContestKey => {
            //il contesto è visibile se:
            //-si tratta del contesto di cui è stato selezionato il tab (serve per il caso in cui ci si trova su un livello)
            //-si tratta di un contesto in cui è stato scelto un candidato da votare (in modo che non si perdano le precedenti selezioni dei candidati)
            this.visibleContests[visibleContestKey] =
              visibleContestKey == this.activeTab ||
              this.selectedContests[visibleContestKey];
          });
        }
        //nasconde i tab non selezionati
        let tabs = document
          .getElementById("esterno")
          .querySelectorAll(".md-tab");

        tabs.forEach(x => x.setAttribute("aria-hidden", "true"));
        document
          .getElementById(this.activeTab)
          .setAttribute("aria-hidden", "false");
        //document.getElementById(this.actualTab).focus();

        this.$forceUpdate();
      }
    },
    numberCandidates(value) {
      this.numCandidates = value;
    },
    getOuterNavButtons() {
      return document
        .getElementById("esterno")
        .querySelector("div")
        .querySelectorAll("button");
    },
    getFirstOuterNavButton() {
      return document
        .getElementById("esterno")
        .querySelector("div")
        .querySelector("button:enabled");
    },
    getActiveTabButtons() {
      return document
        .getElementById(this.activeTab)
        .querySelectorAll("a,button");
    },
    getFirstActiveTabButton() {
      return document.getElementById(this.activeTab).querySelector("a,button");
    },
    getFirstToolbarButton() {
      //reperisce i bottoni della toolbar abilitati
      let enabledToolbarButtons = document
        .querySelector(".innertoolbar")
        .querySelectorAll("button:enabled");

      return enabledToolbarButtons.length > 0 ? enabledToolbarButtons[0] : null;
    },
    getLastToolbarButton() {
      //reperisce i bottoni della toolbar abilitati
      let enabledToolbarButtons = document
        .querySelector(".innertoolbar")
        .querySelectorAll("button:enabled");

      return enabledToolbarButtons.length > 0
        ? enabledToolbarButtons[enabledToolbarButtons.length - 1]
        : null;
    },
    handleTabCandidatesNavigation(event) {
      let actualElement = event.target;

      //se ci sono dei contesti
      if (this.contestLevels > 0) {
        //reperisce i bottoni di navigazione "esterni"
        let outerNavButtons = this.getOuterNavButtons();

        //reperisce il primo bottone della toolbar abilitato
        let firstToolbarButton = this.getFirstToolbarButton();

        //se è stata usata la combinazione di tasti SHIFT+TAB
        if (event.shiftKey) {
          //se ci si trova sul primo bottone della toolbar
          if (
            firstToolbarButton != null &&
            actualElement == firstToolbarButton
          ) {
            //se non è stato selezionato alcun tab di navigazione
            if (this.activeTab == null) {
              //se c'è un solo livello di bottoni di navigazione
              outerNavButtons[outerNavButtons.length - 1].focus();
            }
            //se è stato selezionato un tab di navigazione
            else {
              //recupera tutti i bottoni all'interno del tab attivo
              let activeTabButtons = this.getActiveTabButtons();

              //dà il focus all'ultimo bottone del tab selezionato
              if (activeTabButtons[activeTabButtons.length - 1].disabled) {
                activeTabButtons[activeTabButtons.length - 2].focus();
              } else {
                activeTabButtons[activeTabButtons.length - 1].focus();
              }
            }

            //impedisce il propagarsi dell'evento SHIFT+TAB
            event.preventDefault();
          }
          //se non ci si trova sul primo bottone della toolbar ed è stato selezionato un tab
          else if (this.activeTab != null) {
            //recupera il primo bottone all'interno del tab attivo
            let firstActiveTabButton = this.getFirstActiveTabButton();

            //se ci si trova sul primo bottone del tab attivo
            if (actualElement == firstActiveTabButton) {
              //se c'è un solo livello di bottoni di navigazione
              //dà il focus all'ultimo bottone di navigazione esterno
              outerNavButtons[outerNavButtons.length - 1].focus();

              //impedisce il propagarsi dell'evento SHIFT+TAB
              event.preventDefault();
            }
          }
        }
        //se è stato usato il tasto TAB
        else {
          //se non è stato selezionato alcun tab di navigazione
          if (this.activeTab == null) {
            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone di navigazione esterno
            if (actualElement == outerNavButtons[outerNavButtons.length - 1]) {
              //se c'è un solo livello di bottoni di navigazione
              //se c'è un bottone della toolbar abilitato
              if (firstToolbarButton != null) {
                //dà il focus al primo bottone della toolbar abilitato
                firstToolbarButton.focus();

                //impedisce il propagarsi dell'evento TAB
                event.preventDefault();
              }
            }
          }
          //se è stato selezionato un tab di navigazione
          else {
            //recupera tutti i bottoni all'interno del tab attivo
            let activeTabButtons = this.getActiveTabButtons();

            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone di navigazione esterno
            if (actualElement == outerNavButtons[outerNavButtons.length - 1]) {
              //dà il focus al primo bottone del tab attivo
              activeTabButtons[0].focus();

              //impedisce il propagarsi dell'evento TAB
              event.preventDefault();
            }
            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone del tab attivo
            //oppure è il penultimo e l'ultimo è disabilitato
            else if (
              actualElement == activeTabButtons[activeTabButtons.length - 1] ||
              (actualElement == activeTabButtons[activeTabButtons.length - 2] &&
                activeTabButtons[activeTabButtons.length - 1].disabled)
            ) {
              //se c'è un bottone della toolbar abilitato
              if (firstToolbarButton != null) {
                //dà il focus al primo bottone della toolbar abilitato
                firstToolbarButton.focus();
              }

              //impedisce comunque il propagarsi dell'evento TAB
              event.preventDefault();
            }
          }
        }
      }
    },

    handleContestTabNavigation(e) {
      let focusable = document
        .querySelector("#preference-modal2")
        .querySelectorAll("a,button:enabled");

      if (focusable.length) {
        let first = focusable[0];
        let last = focusable[focusable.length - 1];
        let shift = e.shiftKey;

        if (shift) {
          if (e.target === first) {
            last.focus();
            e.preventDefault();
          } else {
            this.handleTabCandidatesNavigation(e);
          }
        } else {
          if (e.target === last) {
            first.focus();
            e.preventDefault();
          } else {
            this.handleTabCandidatesNavigation(e);
          }
        }
      }
    },
    checkContestName(contestName) {
      return contestName != null && contestName != "";
    }
  },
  computed: {
    unorderedContests() {
      return new Utils().unorderedContests(this.contestList);
    },
    orderedContests() {
      return new Utils().orderedContests(this.contestList);
    },
    contestLevels: function() {
      // calcola quanti livelli di tab devono essere visualizzati [0..2]
      return this.unorderedContests.length > 1 ? 1 : 0;
      /*this.orderedContests.length > 1
        ? 2
        :*/
    }
  },
  components: {
    Contest: () => import("./Contest"),
    NoAllPreferenceDialog,
    InfoBox
    // EqualOppDialog
  }
};
</script>
<style scoped>
.title-alert {
  font-weight: bold;
  font-size: 24px;
  padding: 12px;
  background: #fff3cd;
  border-radius: var(--br);
  background-color: var(--pcolor);
  margin: 10px 20px;
  color: #fff;
  flex: 1 1 100%;
  text-align: center;
  font-size: 16px;
}

.bg-preference {
  background: #f5f5f5;
  padding-top: 30px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 30px;
}

.dialog {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
}

.toolbar {
  position: sticky !important;
  bottom: 0px !important;
  width: 100% !important;
}
.mg {
  margin: 10px;
  padding: 2px;
}
.dis {
  pointer-events: none;
}
.md-button {
  border-radius: var(--brb);
  padding: 0px 24px;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
  box-shadow: none;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
  box-shadow: none;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
}

.md-button.md-theme-default[disabled].md-primary .md-icon-font {
  color: rgba(0, 0, 0, 0.8) !important;
}
.md-button.md-theme-default.md-raised[disabled] {
  color: #3d3d3d;
}
.md-card {
  box-shadow: none !important;
  border: 1px solid #dedede !important;
}

#confirmPreference {
  margin-left: 10px;
}

.preferenze-label {
  font-weight: bold;
  font-size: 14px;
  color: var(--pcolor) !important;
  padding-top: 8px;
}

.btn-align {
  text-align: center;
}

.md-subtitle {
  xmargin-bottom: 30px !important;
}

.md-tabs-navigation {
  background: #448aff !important;
  color: #fff !important;
}
.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active,
.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active .md-icon {
  color: var(--pcolor) !important;
  background-color: transparent !important;
}

.md-tabs-content {
  height: 100vh !important;
  max-height: 60% !important;
}
.md-tabs-content {
  height: 100vh !important;
  max-height: 60% !important;
}
.md-tabs-indicator {
  background-color: var(--pcolor) !important;
  background-color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  );
}
.light-w {
  width: 100% !important;
  display: grid !important;
  grid-template-rows: auto 1fr;
}
@media screen and (max-width: 667px) {
  .md-dialog.all {
    height: 40vh !important;
  }
  .md-layout {
    flex: 1;
  }
}
</style>
